import { render } from "./ServiceChip.vue?vue&type=template&id=7dd5803c&scoped=true"
import script from "./ServiceChip.vue?vue&type=script&lang=js"
export * from "./ServiceChip.vue?vue&type=script&lang=js"

import "./ServiceChip.vue?vue&type=style&index=0&id=7dd5803c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd5803c"]])

export default __exports__